<template>
  <div class="findPassword">
    <v-topBar :navigationColumnInfos='navigationColumnInfos' :webConfigInfo='webConfigInfo'  :footerColumnInfos='footerColumnInfos' :paramInfo='paramInfo'></v-topBar>
    <v-registerTop :navTitle="navTitle" :webConfigInfo='webConfigInfo'></v-registerTop>
    <!--<div class="setNavBg">-->
    <!--<v-header :navigationColumnInfos='navigationColumnInfos' :webConfigInfo='webConfigInfo'  :footerColumnInfos='footerColumnInfos' :paramInfo='paramInfo'></v-header>-->
    <!--</div>-->
    <div class="registerStepTit"><h3>找回密码</h3></div>
    <div class="registerStepCon">
      <el-steps :active="3" align-center>
        <el-step title="1 基本信息"></el-step>
        <el-step title="2 验证身份"></el-step>
        <el-step title="3 重置密码"></el-step>
        <el-step title="4 操作完成"></el-step>
      </el-steps>
      <div class="completeCon">
        <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/registerSuccess.png" alt="">
        <h5>密码重置成功</h5>
        <p>请使用新密码登录，3s后自动跳转</p>
      </div>
      <el-button @click="goToHref('/')">返回首页</el-button>
    </div>
    
    <v-footer :navigationColumnInfos='navigationColumnInfos' :webConfigInfo='webConfigInfo'  :footerColumnInfos='footerColumnInfos' :paramInfo='paramInfo'></v-footer>
  </div>
</template>
<script>
  import header from '@/components/v-header/header'
  import topBar from '@/components/topBar'
  import registerTop from '@/components/registerTop'
  import footer from '@/components/v-footer'
  export default {
    props: [],
    data () {
      return {
        userAgreementVisible: false,
        privacyPolicyVisible: false,
        centerDialogVisible: false,
        navigationColumnInfos: [],
        footerColumnInfos: [],
        paramInfo:{},
        webConfigInfo: {},
        checkList:[],
        navTitle:'找回密码',
        verifyBtn:'获取验证码',
        disabledBtn:false,
        abroadShow:false,
        baseForm: {
          name: '',
          yzm: ''
        },
        rules: {
          name: [
            { required: true, message: '请输入密码', trigger: 'blur' }
          ],
          yzm: [
            { required: true, message: '请输入密码', trigger: 'blur' }
          ]
        }
      }
    },
    components: {
      'v-header': header,
      'v-topBar': topBar,
      'v-registerTop': registerTop,
      'v-footer': footer
    },
    created () {
      let query = this.$route.query;
      this.webConfigInfo = query.webConfigInfo;
      this.footerColumnInfos = query.footerColumnInfos;
      this.navigationColumnInfos = query.navigationColumnInfos;
      this.paramInfo = query.paramInfo;
    },
    mounted () {
      this.toLogin();
    },
    methods: {
      toLogin(){
        setTimeout(()=>{
          this.goToHref('login');
        },3000);
      },
      goToHref(val){
        this.$router.push({path: val})
      }
      
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/findPassword/passwordComplete.vue